import React, { Component } from "react";
import "./style.css";
import { Route, Switch, Redirect } from "react-router-dom";
import {
  UsersScreen,
  SessionsScreen,
  GymsScreen,
  TrainersScreen,
  OnboardingScreen,
  AnalyticsScreen,
  PromocodesScreen,
  QRListScreen,
  StripeScreen,
  LogScreen,
  FlatRatesScreen,
  DynamicPricingScreen,
  PostWorkoutDataScreen,
  WalletPricesScreen,
  AdminConfigScreen,
  VPTDashboard,
  AdminUsersScreen,
  WorkoutScreen
} from "screens/App";

import Navbar from "components/Navbar";
class AppContainer extends Component {
  render() {
    return (
      <div className="div__AppContainer">
        <Navbar />
        <main>
          <Switch>
            <Route path="/users" component={UsersScreen} />
            <Route path="/sessions" component={SessionsScreen} />
            <Route path="/gyms" component={GymsScreen} />
            <Route path="/trainers" component={TrainersScreen} />
            <Route path="/vpt" component={VPTDashboard} />
            <Route path="/onboarding" component={OnboardingScreen} />
            <Route path="/analytics" component={AnalyticsScreen} />
            <Route path="/dynamicPricing" component={DynamicPricingScreen} />
            <Route path="/postWorkoutData" component={PostWorkoutDataScreen} />
            <Route path="/walletPrices" component={WalletPricesScreen} />
            <Route path="/promocodes" component={PromocodesScreen} />
            <Route path="/adminConfig" component={AdminConfigScreen} />
            <Route path="/qrlist" component={QRListScreen} />
            <Route path="/stripe" component={StripeScreen} />
            <Route path="/log" component={LogScreen} />
            <Route path="/flat-rate" component={FlatRatesScreen} />
            <Route path="/admins" component={AdminUsersScreen} />
            <Route path="/workouts" component={WorkoutScreen} />
            <Route exact={true} path="/" render={() => (
              <Redirect to="/users/" />
            )} />
          </Switch>
        </main>
      </div>
    );
  }
}

export default AppContainer;
